import { useLogger } from "@/composables/logger";
import type { ModelsResolver } from "@/models/resolvers";

const { info: logInfo } = useLogger("SIZINGS_RESOLVER");

export default {
  queries: {
    sizing_imports: {
      legacy_user: (parent, args, cache, info) => {
        return parent.legacy_author_id
          ? {
              __typename: "legacy_users",
              hal_identifier: parent.legacy_author_id
            }
          : "";
      }
    }
  }
} as ModelsResolver;
